import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import ky, { KyInstance } from 'ky'
import Cookie from 'js-cookie'

import { useUserStore } from '@/stores/app/user'
import { cookies } from '@/utils/constants'

const requestKy = ky.create({
    cache: 'no-cache',
    prefixUrl: process.env.REACT_APP_API_ADDRESS,
    retry: 2,
})

type UseApiStore = {
    /** Request the backend as logged out and without the hooks. */
    requestWithoutHooks: KyInstance

    /** Request the backend as logged in. */
    request: KyInstance
}

export const useApiStore = create<UseApiStore>()(
    immer(() => ({
        requestWithoutHooks: requestKy,

        request: requestKy.extend({
            hooks: {
                beforeRequest: [
                    async (requestParameter) => {
                        const { updateTokens } = useUserStore.getState()
                        await updateTokens()

                        const accessToken = Cookie.get(
                            cookies.tokens.ACCESS_TOKEN,
                        )

                        requestParameter.headers.set(
                            'Authorization',
                            `JWT ${accessToken}`,
                        )
                    },
                ],
            },
        }),
    })),
)
